/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Modal } from 'antd-mobile'
import useRootStore from '@store/useRootStore'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'

import { mq, TxtLimit, ModalBg } from '@styles/base.style'
import * as _ from 'lodash'
import { Button, ButtonWrap, PopupBtnStyle } from '@styles/button.style'
import { ChangeRateData } from '@store/matchupStore'
// css
import styled from '@themes/theme'

const ChangeRateWrap = styled.div`
  position: relative;
  height: 100%;
  overflow-x: visible;
`
const ModalTxt = styled.p`
  display: block;
  margin: 0 auto;
  color: ${props => props.theme.color.modalred};
  font-size: ${props => props.theme.font.medium};
`
const ChangeRateListWrap = styled.div`
  z-index: 2;
  position: relative;
  width: 100%;
  margin: 20px 0;
  overflow: none;
  background-color: ${props => props.theme.color.modalSubBg};
  border-top: 2px solid ${props => props.theme.color.modalSubBg};
  border-bottom: 2px solid ${props => props.theme.color.modalSubBg};
`
const HiddenWrap = styled.div`
  position: relative;
  width: 100%;
  height: 26px;
  padding: 0 20px;
  line-height: 2.5rem;
  text-align: left;
  background: ${props => props.theme.color.modalSubBg2};
  * {
    font-size: ${props => props.theme.font.small};
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 2px solid ${props => props.theme.color.modalSubBg};
  }
  &:last-of-type::before {
    display: none;
  }
`
const TeamWrap = styled.div`
  position: relative;
  width: calc(58.5% - 4px); /* 4px은 padding-left 값 */
  float: left;
  text-align: left;
  ${mq[0]} {
    width: calc(52.6% - 4px);
  }
`
const TeamNameTxt = styled.span`
  float: left;
  width: auto;
  max-width: 42%;
  color: ${props => props.theme.color.modalTxt};
`
const Score = styled.span`
  width: 16%;
  float: left;
  text-align: center;
  color: ${props => props.theme.color.modalSubTxt};
`
const RateWrap = styled.div`
  position: relative;
  width: auto;
  max-width: calc(41.5% + 4px); /* 4px은 padding-left 값 */
  float: left;
  padding-left: 4px;
  color: ${props => props.theme.color.modalTxt};
  ${mq[0]} {
    max-width: calc(47.4% + 4px);
  }
  &::after {
    content: '';
    display: block;
    clear: both;
  }
`
const Origin = styled.span`
  margin-right: 4px;
  color: ${props => props.theme.color.modalTxt};
  .rate {
    color: ${props => props.theme.color.modalOrange};
  }
`
const Change = styled.span`
  margin-left: 4px;
  color: ${props => props.theme.color.modalTxt};
  .rate.up {
    color: ${props => props.theme.color.red};
  }
  .rate.down {
    color: ${props => props.theme.color.blue};
  }
`
const Rate = styled.span`
  margin-left: 4px;
  color: ${props => props.theme.color.modalOrange};
`

const generateRow = (item: ChangeRateData, rowIndex: number) => {
  let ele
  const { from, to, marketType } = item
  if (from && to) {
    let className = 'rate up'
    if (from.rate > to.rate) {
      className = 'rate down'
      /* 배당률 올랐을 때 */
    }
    ele = (
      <HiddenWrap key={`hidden-wrap-${rowIndex}-${marketType}`}>
        <TeamWrap>
          <TeamNameTxt css={TxtLimit}>{item.homeTeamName}</TeamNameTxt>
          <Score>VS</Score>
          <TeamNameTxt css={TxtLimit}>{item.awayTeamName}</TeamNameTxt>
        </TeamWrap>
        <RateWrap>
          <Origin>
            기존<Rate className="rate"> {`[${!_.isNil(from.rate) ? from.rate.toFixed(2) : ''}]`}</Rate>
          </Origin>
          &#8594;
          <Change>
            변경<Rate className={className}>{`[${!_.isNil(to.rate) ? to.rate.toFixed(2) : ''}]`}</Rate>
          </Change>
        </RateWrap>
      </HiddenWrap>
    )
  }

  return ele
}

const ChangeRatePopup: React.FC = () => {
  const { componentStore, matchupStore } = useRootStore()

  const { componentBettingParams } = componentStore

  let visible = false
  const eleContents = []

  let onClick

  if (componentBettingParams) {
    const { changeRate = [] } = componentBettingParams

    visible = changeRate.length > 0
    let rowIndex = 1
    for (const item of changeRate) {
      const { from, to } = item
      if (to.rate - from.rate !== 0) {
        const el = generateRow(item, rowIndex)
        if (el) {
          eleContents.push(el)
        }
      }
      rowIndex += 1
    }

    onClick = () => {
      componentStore.clearChangeRate()
    }
  }

  const onClickChangeRatePopupCloseButton = () => {
    if (componentBettingParams) {
      return
    }

    matchupStore.toggleChangeRateCollapsed(true)
  }

  return (
    <Modal
      popup
      visible={visible}
      maskClosable={false}
      animated={isMobile}
      animationType="slide-up"
      onClose={onClickChangeRatePopupCloseButton}
      title="배당률이 변경되었습니다."
      className="short-top change-rate"
    >
      <ChangeRateWrap>
        {!componentBettingParams && (<ModalTxt>변경된 배당률을 확인하시겠습니까?</ModalTxt>)}
        <ChangeRateListWrap>{eleContents}</ChangeRateListWrap>

        <ButtonWrap>
          <Button secondary css={PopupBtnStyle} onClick={onClick} className="one-button bottom-btn">
            확인
          </Button>
        </ButtonWrap>
      </ChangeRateWrap>

      <ModalBg onClick={onClickChangeRatePopupCloseButton}/>
    </Modal>
  )
}
export default observer(ChangeRatePopup)
